import { useEffect } from 'react'

import { getQueryParam } from 'utils'
import { track, useTracking } from 'lib/analytics'
import { Registry } from 'src/types/registry'
import { useRegistry } from 'src/routes/(registry)/list/[slug]/utils/useQueries'

const ENTRY_POINT_QUERY_PARAM = 'entry_point'

const ShipmentsEntryPoint = {
  ACCOUNT_MENU: 'account_menu',
  GIFT_TRACKER: 'gift_tracker',
  MOBILE_NAVBAR: 'mobile_navbar',
  FEED_NOTICE_BUNDLE: 'feed_notice_bundle',
  FEED_NOTICE_SHIPMENT: 'feed_notice_shipment',
  ORDERS: 'orders',
}

const validateShipmentsEntryPoint = (entryPoint: string | null) =>
  entryPoint && Object.values(ShipmentsEntryPoint).includes(entryPoint)
    ? entryPoint
    : null

const entryPointQueryParam = () => getQueryParam(ENTRY_POINT_QUERY_PARAM)

const shipmentsEntryPoint = () =>
  validateShipmentsEntryPoint(entryPointQueryParam())

const consolidationValue = ({
  shippingConsolidation: { consolidationChoice },
}: Registry) =>
  !consolidationChoice
    ? track.ConsolidationValue.MODAL_NOT_VIEWED
    : consolidationChoice

const shipmentsPageViewEvent = (registry: Registry | undefined) => ({
  event: track.EventType.PAGE_VIEWED,
  eventLocation: track.EventLocation.SHIPMENTS,
  consolidationValue: (registry && consolidationValue(registry)) || null,
  entryPoint: shipmentsEntryPoint(),
})

export const withEntryPointAccountMenu = (path: string) =>
  `${path}?${ENTRY_POINT_QUERY_PARAM}=${ShipmentsEntryPoint.ACCOUNT_MENU}`

export const useTrackShipmentsPageView = () => {
  const tracking = useTracking()
  const registry = useRegistry()
  useEffect(() => {
    tracking.trackEvent(shipmentsPageViewEvent(registry))
  }, [])
}
